import Apps from "../../layouts/Apps";
import Carousel from "../../components/apps/Carousel";
import Screenshot2 from "../../assets/img/apps/fundatio/screenshot2.png";
import Screenshot3 from "../../assets/img/apps/fundatio/screenshot3.png";
import Screenshot4 from "../../assets/img/apps/fundatio/screenshot4.png";
import Screenshot5 from "../../assets/img/apps/fundatio/screenshot5.png";
import IconText from "../../components/IconText";
import {
    faCoins,
    faMagicWandSparkles,
    faLink,
    faUserShield,
    faComments,
    faBug,
    faHeadset, faLock, faIdCard
} from "@fortawesome/free-solid-svg-icons";
import Button from "../../components/Button";
import {faApple, faSquareInstagram, faTwitter} from "@fortawesome/free-brands-svg-icons";
import FundatioIcon from "../../assets/img/apps/fundatio/fundatio.png";
import SocialLink from "../../components/SocialLink";

export default function FundatioApp() {
    const images = [
        Screenshot2,
        Screenshot3,
        Screenshot4,
        Screenshot5,
    ];

    const iconStyle = {
        width: "64px",
        height: "64px",
        marginRight: "10px",
        verticalAlign: "middle",
    };

    const headerContainerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px",
        marginBottom: "20px",
    };

    const appNameStyle = {
        display: "flex",
        alignItems: "center",
        margin: 0,
    };

    const warningTextStyle = {
        color: "#ff4d4f",
        fontWeight: "bold",
    };

    const socialsTextStyle = {
        marginTop: "25px",
    };

    const rightContent = (
        <div>
            <div style={headerContainerStyle}>
                <h1 style={appNameStyle}>
                    <img style={iconStyle} src={FundatioIcon} alt={"Fundatio"}/>
                    Fundatio
                </h1>
                <Button
                    icon={faApple}
                    text={"Get Fundatio for macOS"}
                    onClick={() => window.open("https://apps.apple.com/app/fundatio-folder-structurer/id6748969665", "_blank")}
                />
            </div>
            <p>Structure your ideas, with ease.</p>
            <Carousel images={images}/>
            <ul>
                <li><IconText text={"Free"} icon={faCoins} bgColor={true}></IconText> No payments, no subscriptions, no
                    ads.
                </li>
                <li><IconText text={"Versatile"} icon={faUserShield} bgColor={true}></IconText> Structure your projects,
                    whatever your profession is.
                </li>
                <li><IconText text={"AI Assistant"} icon={faMagicWandSparkles} bgColor={true}></IconText> Let Mistral,
                    OpenAI, Anthropic or Deepseek help you. <span style={warningTextStyle}>(API key required)</span>
                </li>
            </ul>
            <p>Create, manage, and deploy folder structures for any project. Fundatio combines visual editing, YAML
                import, and AI-powered generation into a powerful macOS-native tool.</p>

            <h1><IconText icon={faLink} text={"Links"}/></h1>

            <div className="d-flex flex-column gap-2">
                {/*<div className="d-flex flex-wrap gap-2">*/}
                {/*    <Button icon={faComments} text={"Feedback"} to={"/apps/fundatio/feedback"}/>*/}
                {/*    <Button icon={faBug} text={"Bug Report"} to={"/apps/fundatio/bug-report"}/>*/}
                {/*</div>*/}
                <div className="d-flex flex-wrap gap-2">
                    <Button icon={faHeadset} text={"Support"} to={"/apps/fundatio/support"}/>
                    <Button icon={faLock} text={"Privacy Policy"} to={"/apps/fundatio/privacy-policy"}/>
                    <Button icon={faIdCard} text={"License"} to={"/apps/fundatio/license"}/>
                </div>
            </div>

            <p style={socialsTextStyle}>Follow mpospirit.apps on social media:</p>
            <SocialLink icon={faSquareInstagram} text={"Instagram"} linkText={"@mpospirit.apps"}
                        href={"https://www.instagram.com/mpospirit.apps/"}/>
            <br/>
            <SocialLink icon={faTwitter} text={"Twitter"} linkText={"@mpospiritapps\n"}
                        href={"https://twitter.com/mpospiritapps"}/>
        </div>
    )
    return (
        <div className="fundatio-app-page">
            <Apps rightContent={rightContent}/>
        </div>
    )
}
